import React from 'react';
import cx from 'classnames';
import { Image } from 'react-bootstrap';
import styles from './options.module.scss';
import { localizedStrings } from 'src/localization';
import Text from 'src/components/text';


interface EmailOptionViewProps {
  option: any;
  setValue?: (contact: any) => void; 
}

const EmailOptionView: React.FC<EmailOptionViewProps> = ({option, setValue }) => {
  const localizedCommons = localizedStrings.commons;

  const handleOptionSelected = (contact) => {
    if (setValue) {
      setValue(contact);
    }
  };

  const renderOption = (option) => {
    if (option.type === 'contact') {
      return renderContact(option.value);
    } else if (option.type === 'contact_list') {
      return renderContactList(option.value);
    } else if (option.type === 'option_group') {
      return renderOptionGroup(option);
    }
  };

  const renderContact = (contact) => {
    const firstLetter = contact.name ? contact.name.charAt(0).toUpperCase() : 'U';
    return (
      <div key={contact.id} className={styles.contact} onClick={() => handleOptionSelected(contact)}>
        <div className={styles.left}>
          <div className={styles.iconContainer}>
            {!contact.icon ? (
              <div className={styles.contactAvatar}>{firstLetter}</div>
            ) : (
              <Image className={styles.contactIcon} src={contact.icon.thumbnail} roundedCircle />
            )}
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.contactName}>
            <Text text={renderName(contact)} lines={1} />
          </div>
          <div className={styles.contactTitle}>
            <Text text={contact.email || 'No Details'} lines={1} />
          </div>
        </div>
      </div>
    );
  };

  const renderContactList = (contactList) => {
    return (
      <div key={contactList.id} className={styles.contactList} onClick={() => handleOptionSelected(contactList)}>
        <div className={styles.left}>
          <div className={styles.icon}>
            <div className={styles.avatar}>
              <i className="paperflite-group" />
            </div>
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.name}>
            <Text className={styles.contactListName} lines={1} text={contactList.name} />
          </div>
          <div className={styles.members}>
            {contactList.contactCount} {localizedCommons.contacts}
          </div>
        </div>
      </div>
    );
  };

  const renderOptionGroup = (optionGroup) => {
    return (
      <div className={styles.optionGroup}>
        {optionGroup.fetching && `${localizedCommons.contacts_search.searching_contacts}...`}
        {optionGroup.empty && `${localizedCommons.contacts_search.no_contacts_found}`}
      </div>
    );
  };

  const renderName = (contact) => {
    return `${contact.firstName || ''} ${contact.lastName || ''}`;
  };

  return <div className={cx(styles.option)}>{renderOption(option)}</div>;
};

export default EmailOptionView;